<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 ranking-clients">
  <po-widget>
    <div class="po-row">
      <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pl-0">
        <span class="po-font-text-bold">Ranking de Clientes</span>
      </div>
      <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5">
        <po-select name="select" [ngModel]="itemSelected" [p-options]="selectItem"
          (p-change)="changeEventSelect($event)">
        </po-select>
      </div>
    </div>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts width="100%" height="280" type="bar2d" [dataSource]="dataSource">
      </fusioncharts>
    </div>
  </po-widget>
</div>